import React from "react"
import styles from "./hero-wrapper.module.scss"


export default ({children}) => (
  <div className={styles.heroButton}>
    {children}
  </div>
)